import { Button } from '@revenuemarket/cds';
import { useIsMobile } from '@revenuemarket/utils';

import { getIconColor } from './helper';
import * as S from './style';
import { ExclamationCircleIcon } from '../Icon';
import ModalBase from '../ModalBase';
import { ModalAlertProps } from '../types/modal';

export default function ModalAlert({
  isOpen,
  title,
  description,
  buttonConfirmText,
  alertType,
  buttons,
  onClickConfirm,
  handleClose,
  hasCloseButton = true,
  isBlur = false,
}: ModalAlertProps) {
  const handleClickConfirm = () => {
    if (onClickConfirm) {
      onClickConfirm();
    }

    handleClose();
  };
  const isMobile = useIsMobile();

  return (
    <ModalBase
      isOpen={isOpen}
      handleClose={handleClose}
      isBlur={isBlur}
      hasCloseButton={hasCloseButton}
    >
      <S.Wrapper style={{ width: isMobile ? '100%' : '' }}>
        {title && (
          <S.Title>
            {alertType && (
              <S.TitleIcon>
                <ExclamationCircleIcon width={20} height={20} fill={getIconColor(alertType)} />
              </S.TitleIcon>
            )}
            {title}
          </S.Title>
        )}
        {description && <S.Description>{description}</S.Description>}
        <S.ButtonGroup>
          {buttons &&
            buttons.map((buttonInfo) => (
              <Button
                key={buttonInfo.buttonText}
                buttonType={buttonInfo.buttonType ?? 'primary'}
                buttonSize="large"
                onClick={() => {
                  if (buttonInfo.onClick) {
                    buttonInfo.onClick();
                  }

                  handleClose();
                }}
              >
                {buttonInfo.buttonText}
              </Button>
            ))}
          <S.ButtonModal
            buttonType="primary"
            buttonSize="xlarge"
            type="button"
            alertType={alertType}
            onClick={handleClickConfirm}
          >
            {buttonConfirmText ?? '확인'}
          </S.ButtonModal>
        </S.ButtonGroup>
      </S.Wrapper>
    </ModalBase>
  );
}
